// extracted by mini-css-extract-plugin
module.exports = {"back":"prev-module--back--1_VcM","backShow":"prev-module--backShow--3y3lG"};